import { gql } from '@apollo/client';

export const GENERIC_FILTER_PARAM_UPDATED = gql`
  subscription genericFilterParamUpdated {
    genericFilterParamUpdated {
      genericFilterParam {
        paramId
        paramName
        paramCode
        paramTypeId
        inactive
        genericFilterParamXContexts {
          id
          paramId
          contextId
          contextName
        }
      }
    }
  }
`;
